import server from "../../../../server";
import { Document } from "../../../../domains/models/document";
import dayjs from "dayjs";
import { IEmployeeDocument } from "../type/employee-document-list.types";
import { Document_Type } from "../../../../constant/constant";
import { getImageUrl } from "../../../../utility/utility";

export async function fetchDocument(empId: string) {
    const params={employeeId:empId}
    const docs = await server.document.find(params);
    return docs;
}

export async function deleteDocument(id: string) {
    await server.document.delete(id);
}

export async function downLoadDocument(id: string) {
    const response = await server.document.download(id);
    return response;
}


export function viewMapper(response: Document[]) {
    return response.map((doc: Document) => {
        const documentKey = doc.documentType as keyof typeof Document_Type;
        return {
            id: doc.id,
            name: Document_Type[documentKey], //as per requirement, setting name document type for employee docs.
            type: Document_Type[documentKey],
            contentType: doc.contentType,
            documentNumber: doc.documentNumber,
            thumbnailUrl: getImageUrl(doc, 'medium'),
            documentType: documentKey,
            size: doc.size,
            date: dayjs(doc.auditInfo?.updatedOn).format('YYYY-MM-DD')
        }
    })
}

export function mapUploadDocumentResponse(doc: Document[], docType: keyof typeof Document_Type): IEmployeeDocument[] {
    const todayDate = dayjs().format('YYYY-MM-DD')
    return doc.map((item) => {
        return {
            id: item.id,
            contentType: item.contentType,
            documentType: docType,
            thumbnailUrl: getImageUrl(item, 'medium'),
            name: item.originalFileName,
            size: item.size,
            date: todayDate,
            type: Document_Type[docType]
        }
    })
}
